import useStore from "../../../store"
import { useTranslation } from "react-i18next"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import formatter from "../../../constants/currencyFormatter"
import { NeutralButton } from "../../common/Buttons"
import SwipeAnimation from "../../common/SwipeAnimation"
import useUserType from "../../../hooks/useUserType"

export default function NAPSuccess({ issues = false }) {
  const { t } = useTranslation()
  const blackbook = useStore((state) => state.NAPBlackbook)
  const napId = useStore((state) => state.napId)
  const resetNAPSlice = useStore((state) => state.resetNAPSlice)
  const fetchUnits = useStore((state) => state.fetchUnits)
  const subscribeToUnit = useStore((state) => state.subscribeToUnit)
  const floorAmount = useStore((state) => state.NAPFloorAmount)
  const navigate = useNavigate()
  const setBreadcrumbTrail = useStore((state) => state.setBreadcrumbTrail)
  const breadcrumbTrail = useStore((state) => state.breadcrumbTrail)
  const dealer = useStore((state) => state.dealer)
  const { isEmployee, isDealer } = useUserType()

  useEffect(() => {
    fetchUnits()
    if (isDealer && napId) {
      subscribeToUnit(napId)
    }
  }, [])

  const handleClickViewUnit = () => {
    if (isEmployee) {
      const newBreadcrumbTrail = [
        ...breadcrumbTrail.slice(0, -1),
        {
          label: `${blackbook.model_year} ${blackbook.make} ${blackbook.model}`,
        }
      ]
      setBreadcrumbTrail(newBreadcrumbTrail)
    }
    resetNAPSlice()
    navigate(`/unit/${napId}`)
  }

  const handleClickReturnToDealer = () => {
    if (isEmployee) {
      const newBreadcrumbTrail = [
        ...breadcrumbTrail.slice(0, -2),
        {
          label: dealer?.attributes.name,
          path: `/dealers/${dealer.id}`
        }
      ]
      setBreadcrumbTrail(newBreadcrumbTrail)
    }
    resetNAPSlice()
    navigate(`/dealers/${dealer.id}`)
  }

  return(
    <SwipeAnimation>
      <div className="flex flex-col items-center justify-between pt-6 rounded w-full h-full">
        <div className="text-center">
          <div className="text-2xl">{t("Success!!")}</div>
          <div className="text-grey-300 my-2">
            {t("You have successfully created a floor request")}
          </div>
        </div>

        <div className="flex flex-col items-center w-full text-2xl text-grey-300 py-16 bg-grey-900 rounded">
          <div className="text-grey-100 text-3xl text-center">
            {`${blackbook.model_year} ${blackbook.make} ${blackbook.model}`}
          </div>
          <div>
            {blackbook.vin}
          </div>
          <div>
            {!issues && formatter.format(floorAmount)}
          </div>
        </div>

        <div className="flex flex-col items-center">
          {napId &&
            <NeutralButton
              text={t("View Unit")}
              onClick={handleClickViewUnit}
              style="my-2 text-lg"
            />
          }
          <NeutralButton
            text={t("Return to Dashboard")}
            onClick={() => {
              resetNAPSlice()
              navigate('/')
            }}
            style={`${isDealer ? 'mb-16': 'mb-2'} text-lg`}
          />
          {isEmployee &&
            <NeutralButton
              text={`Return to ${dealer?.attributes.name}`}
              onClick={handleClickReturnToDealer}
              style="mb-16 text-lg"
            />
          }
        </div>
      </div>
    </SwipeAnimation>
  )
}